import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

const state = {
  delivery: {
    id: "",
    currentId: "",
    interventProductID: "",
    agencyId: "",
    additionalCode: "",
    deliveryDateStart: "",
    deliveryDateEnd: "",
    selectedHours: "",
    selectedDate: "",
    postalCode: "",
    slotId: "",
    fakeSlot: false,
    responseData: {
      agenciesData: {},
      calendarData: {},
    },
    slotAvailability: {
      slotUpdatedAt:"",
      serverDate:"",
    },
    isDeliveryDateAvailable: true,
  },
};

export default {
  state,
  mutations,
  getters,
  actions,
};
